const FtmCheckInVerification = ({ verificationData }) => {
    if (!verificationData) {
        return null;
    }

    const { ftm_check_in_verification_image_path } = verificationData;

    return (
        <div className="card card-body">
            <div className="row gx-4">
                <div className="col-auto">
                    <div className="avatar avatar-xl position-relative">
                        <img 
                            src={ftm_check_in_verification_image_path}
                            alt="profile_image" 
                            className="w-100 border-radius-lg" 
                            style={{ minWidth: '80px', maxWidth: '80px', minHeight: '80px', maxHeight: '80px' }}
                        />
                    </div>
                </div>
                <div className="col-auto my-auto">
                    <div className="h-100">
                        <h5 className="mb-1">
                            On-site verification
                        </h5>
                        <p className="mb-0 font-weight-normal text-sm">
                            Tradesperson checked in with the verification image.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FtmCheckInVerification;